"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _questproject = _interopRequireDefault(require("./questproject.graphql"));
var _questprojectadmin = _interopRequireDefault(require("./questprojectadmin.graphql"));
var _logTableRenders = _interopRequireDefault(require("../../../helpers/logTableRenders.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var permissionsTable = function permissionsTable() {
  var byProject = {
    query: _questproject["default"],
    rowKey: 'eventId',
    handle: 'questProjectQuery',
    columns: [{
      name: 'eventAt',
      label: 'Change Date',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      },
      width: '170px'
    }, {
      name: 'group.group.groupId',
      label: 'Quest Project ID',
      sort: true,
      filter: true
    }, {
      name: 'group.group.label',
      label: 'Quest Project Label',
      sort: true,
      filter: true
    }, {
      name: 'targetPawn.pawn.pawnId',
      label: 'Quest Project Admin ID',
      sort: true,
      filter: true
    }, {
      name: 'targetPawn.user.username',
      label: 'Quest Project Admin Username',
      sort: true,
      filter: true
    }, {
      name: 'metadata',
      label: 'Permissions Change',
      sort: true,
      filter: true,
      render: _logTableRenders["default"].permissionsChangeRender
    }]
  };
  var byAdmin = {
    query: _questprojectadmin["default"],
    rowKey: 'eventId',
    handle: 'questProjectAdminQuery',
    columns: [{
      name: 'eventAt',
      label: 'Change Date',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      },
      width: '170px'
    }, {
      name: 'pawnId',
      label: 'Quest Project Admin ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.user.username',
      label: 'Quest Project Admin Username',
      sort: true,
      filter: true
    }, {
      name: 'targetGroup.group.groupId',
      label: 'Quest Project ID',
      sort: true,
      filter: true
    }, {
      name: 'targetGroup.group.label',
      label: 'Quest Project Label',
      sort: true,
      filter: true
    }, {
      name: 'metadata',
      label: 'Permissions Change',
      sort: true,
      filter: true,
      render: _logTableRenders["default"].permissionsChangeRender
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "permissionsAlterations",
    saveState: true,
    views: [{
      handle: 'changesByProject',
      title: 'Permissions Alterations - by Quest Project',
      table: byProject
    }, {
      handle: 'changesByPawn',
      title: 'Permissions Alterations - by Quest Project Admin',
      table: byAdmin
    }]
  }));
};
var _default = exports["default"] = {
  name: 'permissions',
  title: 'Permissions Changes',
  content: permissionsTable()
};